<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>Edit cPay Configuration</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label :for="field.name">{{ field.label }}:</label>

              <input v-if="field.name === 'cpayConfigurationId' || field.name === 'cpayName'"
                     :id="field.name"
                     v-model="editedConfig[field.name]"
                     :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${String(editedConfig[field.name]).length * 10}px` : '100px' }"
                     type="text"
                     class="form-control responsive-input"
                     disabled>

              <input v-else-if="field.name === 'secret' || field.name === 'checkoutPage' || field.name === 'paymentGateway'"
                     :id="field.name"
                     v-model="editedConfig[field.name]"
                     :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text"
                     class="form-control responsive-input">

              <select v-else-if="field.name === 'application'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="max-width: 500px;">
                <option v-for="app in applicationList" :key="app" :value="app">{{ app }}</option>
              </select>

              <input v-else-if="field.name === 'percentage'"
                     :id="field.name"
                     :value="editedConfig.percentage + '%'"
                     type="text"
                     class="form-control responsive-input"
                     style="min-width: 120px;"
                     disabled>

              <input class="checkbox" v-else-if="field.name === 'whatsappEnabled'"
                     type="checkbox"
                     :id="field.name"
                     v-model="editedConfig[field.name]">

              <input class="checkbox" v-else-if="field.name === 'active' || field.name === 'status'"
                     type="checkbox"
                     :id="field.name"
                     v-model="editedConfig[field.name]"
                     disabled>
            </div>
            <p class="text-muted">
              Percentage, Active and Status are read-only here — they're managed on the
              <router-link :to="{ name: 'PaymentManagement' }">Payment Management</router-link> page and
              the backend ignores these fields when saving from this form.
            </p>

            <div v-if="error != ''" class="error-message">{{ error }}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">Save Changes</a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import { CpayConfig } from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'CpayEdit',
  components: {
    Header,
  },
  data() {
    return {
      editedConfig: {
        cpayConfigurationId: this.$route.params.id,
        cpayName: this.$route.params.cpayName,
        secret: this.$route.params.secret,
        checkoutPage: this.$route.params.checkoutPage,
        paymentGateway: this.$route.params.paymentGateway,
        application: this.$route.params.application,
        percentage: Number(this.$route.params.percentage) || 0,
        whatsappEnabled: (this.$route.params.whatsappEnabled === 'true'),
        active: (this.$route.params.active === 'true'),
        status: (this.$route.params.status === 'true')
      },
      applicationList: [],
      fields: [
        { name: "cpayConfigurationId", label: "cPay Configuration Id" },
        { name: "cpayName", label: "cPay Name" },
        { name: "secret", label: "Secret" },
        { name: "checkoutPage", label: "Checkout Page" },
        { name: "paymentGateway", label: "Payment Gateway" },
        { name: "application", label: "Application" },
        { name: "percentage", label: "Percentage" },
        { name: "whatsappEnabled", label: "WhatsApp Enabled" },
        { name: "active", label: "Active" },
        { name: "status", label: "Status" }
      ],
      error: ""
    }
  },
  created() {
    const storedApps = localStorage.getItem('applicationList');
    if (storedApps) {
      this.applicationList = JSON.parse(storedApps);
    } else {
      AdminService.getApplications().then(() => {
        this.applicationList = JSON.parse(localStorage.getItem('applicationList'));
      });
    }
  },
  methods: {
    saveChanges() {
      // percentage travels along for the model's sake, but CpayConfigurationService on the
      // backend carries the existing row's percentage forward regardless of what's sent here
      // (it's owned by the Payment Management / saveCardPercentages save path instead).
      const dataToSave = new CpayConfig(
          this.editedConfig.cpayConfigurationId,
          this.editedConfig.cpayName,
          this.editedConfig.secret,
          this.editedConfig.checkoutPage,
          this.editedConfig.paymentGateway,
          this.editedConfig.application,
          this.editedConfig.percentage,
          this.editedConfig.whatsappEnabled,
          this.editedConfig.active,
          this.editedConfig.status
      );

      AdminService.updateCpayConfiguration(dataToSave).then(() => {
        alert('Update complete');
        this.$router.push({ name: 'CpayConfig' });
      }).catch((error) => {
        console.error("Error updating cPay configuration:", error);
        if (error.response && error.response.data && error.response.data.message) {
          alert(error.response.data.message);
        }
      });
    }
  }
})
</script>

<style src="../../assets/style.css">
</style>
